import { JSX, Show } from "solid-js";
import { TabKey } from "../types/ui";

interface Props {
  active: TabKey;
  onSelect: (k: TabKey) => void;
  collapsed?: boolean;
  extra?: JSX.Element;
  onToggleCollapse?: () => void;
  onCaseInfoClick: () => void;
}

export default function SideNav(props: Props): JSX.Element {
  const tabs: { key: TabKey; label: string; icon: string }[] = [
    { key: "interview", label: "Interview", icon: "📞" },
    { key: "transcript", label: "Transcript", icon: "📄" },
    { key: "analysis", label: "Analysis", icon: "📊" },
  ];
  return (
    <nav class="w-full min-w-0 flex-none pt-6 bg-gray-50 border-r border-gray-200 flex flex-col relative z-30 min-h-full overflow-x-hidden">
      {tabs.map((t) => (
        <button
          class={`p-3 text-xl ${
            props.active === t.key
              ? "bg-blue-100 text-blue-800"
              : "text-gray-700 hover:bg-gray-100"
          }`}
          onClick={() => props.onSelect(t.key)}
          title={t.label}
        >
          {t.icon}
        </button>
      ))}
      {/* Templates (POC) */}
      <button
        class="p-3 text-xl text-gray-700 hover:bg-gray-100"
        title="Templates"
        onClick={() => {
          const ev = new CustomEvent("open-templates", {});
          window.dispatchEvent(ev);
        }}
      >
        🧩
      </button>
      {/* always show a Case Info button at the bottom */}
      <div class="mt-auto mb-6">
        <button
          class="p-3 text-xl text-gray-700 hover:bg-gray-100 rounded"
          title="Case Info"
          onClick={props.onCaseInfoClick}
        >
          📋
        </button>
      </div>
    </nav>
  );
}
